// استيراد الأيقونات المطلوبة من Font Awesome
import { faPenToSquare, faTrash, faMagnifyingGlass, faCalendarDays } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد مكونات Form, InputGroup, Table من React Bootstrap
import { Form, InputGroup, Table } from "react-bootstrap";
// استيراد Link للتنقل بين الصفحات
import { Link } from "react-router-dom";
// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية والتخزين المؤقت
import { useEffect, useMemo, useState } from "react";
// استيراد كائن Axios المهيأ
import { Axios } from "../../API/Axios";
// استيراد مكون الترقيم
import PaginatedItems from "./paginations/pagination";
// استيراد دالة تحويل تنسيق التاريخ
import TransformData from "../../Helpers/TransformData";
// استيراد سياق اللغة
import { useLanguage } from "../../Context/LanguageContext";
// استيراد ملف الأنماط
import "./Table.css";

// مكون عرض الجدول الرئيسي
export default function TableShow ( props )
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // الحصول على بيانات المستخدم الحالي أو كائن افتراضي
    const currentUser = props.currentUser || { name: "" };
    // حالة للبحث
    const [ search, setSearch ] = useState( "" );
    // حالة لتاريخ التصفية
    const [ date, setDate ] = useState( "" );
    // حالة لنتائج البحث
    const [ searchResults, setSearchResults ] = useState( [] );
    // حالة تحميل البحث
    const [ searchLoading, setSearchLoading ] = useState( false );

    // استخدام useMemo لتخزين البيانات المعروضة مؤقتاً - تحسين الأداء
    const displayedData = useMemo( () =>
    {
        // تحديد البيانات الأساسية (نتائج البحث أو البيانات الأصلية)
        const base = search.length > 0 ? searchResults : props.data;
        // تصفية البيانات حسب التاريخ إذا تم تحديده
        return date.length > 0
            ? base.filter( ( item ) => TransformData( item.created_at ) === date )
            : base;
    }, [ search, searchResults, props.data, date ] ); // إعادة الحساب عند تغيير هذه التبعيات

    // دالة غير متزامنة لجلب نتائج البحث
    async function fetchSearchResults ()
    {
        try
        {
            // إرسال طلب POST للبحث - استخدام props.searchLinck لتحديد نقطة النهاية
            const res = await Axios.post( `${ props.searchLinck }/search?title=${ search }` );
            // تخزين نتائج البحث
            setSearchResults( res.data );
        } catch ( error )
        {
            // طباعة خطأ البحث في وحدة التحكم
            console.log( "Error searching:", error );
        } finally
        {
            // إلغاء حالة تحميل البحث
            setSearchLoading( false );
        }
    }

    // تأثير جانبي للبحث مع خاصية debounce (تأخير التنفيذ)
    useEffect( () =>
    {
        // تأخير تنفيذ البحث لمدة 400 مللي ثانية لتقليل عدد الطلبات
        const debounce = setTimeout( () =>
        {
            // إذا كان هناك نص في البحث، قم بجلب النتائج
            search.length > 0 ? fetchSearchResults() : setSearchLoading( false );
        }, 400 );
        // تنظيف المؤقت عند تغيير البحث أو إلغاء تحميل المكون
        return () => clearTimeout( debounce );
        // تعطيل تحذير ESLint لأن التبعيات محددة بشكل صحيح
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ search ] ); // إعادة التشغيل عند تغيير نص البحث

    // دالة غير متزامنة لحذف عنصر
    async function handleDelete ( id )
    {
        try
        {
            // إرسال طلب DELETE لحذف العنصر
            await Axios.delete( `/${ props.delete }/${ id }` );
            // إذا كانت هناك دالة حذف في الخصائص، استدعائها
            if ( props.delete ) props.delete();
        } catch ( error )
        {
            // طباعة خطأ الحذف في وحدة التحكم
            console.log( "Error deleting:", error );
        }
    }

    // دالة لعرض محتوى الخلية حسب نوع العمود
    function renderCell ( item, columnKey )
    {
        // عمود الاسم - عرض الحرف الأول كأفاتار
        if ( columnKey === "name" )
        {
            // استخراج الحرف الأول من الاسم وتحويله إلى أحرف كبيرة
            const initial = item.name ? item.name.charAt( 0 ).toUpperCase() : "?";
            return (
                <div className="name-cell">
                    <span className="name-cell-avatar">{ initial }</span> {/* الأفاتار */ }
                    <span>{ item.name }</span> {/* الاسم */ }
                </div>
            );
        }

        // عمود الصورة - عرض صورة مصغرة
        if ( columnKey === "image" )
        {
            return <img className="cell-thumb" src={ item[ columnKey ] } alt="" />;
        }

        // عمود الصور المتعددة - عرض مجموعة صور مصغرة
        if ( columnKey === "images" )
        {
            return (
                <div className="d-flex align-items-center justify-content-start gap-2 flex-wrap">
                    {/* تكرار على كل صورة وعرضها */ }
                    { item[ columnKey ].map( ( img ) => (
                        <img className="cell-thumb" src={ img.image } alt="" key={ img.id } />
                    ) ) }
                </div>
            );
        }

        // عمود التواريخ - تنسيق التاريخ باستخدام TransformData
        if ( columnKey === "created_at" || columnKey === "updated_at" )
        {
            return <span className="cell-muted">{ TransformData( item[ columnKey ] ) }</span>;
        }

        // عمود الدور - عرض شارة الدور المترجمة
        if ( columnKey === "role" )
        {
            return <span className="role-chip">{ t( `roles.${ item[ columnKey ] }` ) }</span>;
        }

        // باقي الأعمدة - عرض القيمة كما هي
        return item[ columnKey ];
    }

    // عرض واجهة الجدول
    return (
        <div className="data-table-card"> {/* بطاقة الجدول */ }
            {/* شريط أدوات الجدول (بحث وتصفية) */ }
            <div className="data-table-toolbar">
                {/* حقل البحث */ }
                <InputGroup className="toolbar-input-group">
                    <InputGroup.Text><FontAwesomeIcon icon={ faMagnifyingGlass } /></InputGroup.Text>
                    <Form.Control
                        type="search"
                        placeholder={ t( 'table.searchPlaceholder' ) } // نص البحث المترجم
                        aria-label="search-example"
                        onChange={ ( e ) =>
                        {
                            setSearch( e.target.value ); // تحديث نص البحث
                            setSearchLoading( true ); // تفعيل حالة تحميل البحث
                        } }
                    />
                </InputGroup>

                {/* حقل تصفية التاريخ */ }
                <InputGroup className="toolbar-input-group toolbar-date-group">
                    <InputGroup.Text><FontAwesomeIcon icon={ faCalendarDays } /></InputGroup.Text>
                    <Form.Control
                        type="date"
                        aria-label="filter-by-date"
                        onChange={ ( e ) => setDate( e.target.value ) } // تحديث تاريخ التصفية
                    />
                </InputGroup>
            </div>

            {/* جدول البيانات */ }
            <Table responsive className="data-table">
                <thead> {/* رأس الجدول */ }
                    <tr>
                        <th className="text-center">Id</th> {/* عمود المعرف */ }
                        { props.header.map( ( column ) => ( // تكرار على الأعمدة من الخصائص
                            <th key={ column.key }>{ column.name }</th>
                        ) ) }
                        <th className="text-center">{ t( 'table.action' ) }</th> {/* عمود الإجراءات */ }
                    </tr>
                </thead>
                <tbody> {/* جسم الجدول */ }
                    { props.loading ? ( // إذا كان التحميل جارياً
                        <tr>
                            <td colSpan={ props.header.length + 2 } className="text-center table-status-row">
                                { t( 'table.loading' ) } {/* نص التحميل */ }
                            </td>
                        </tr>
                    ) : searchLoading ? ( // إذا كان البحث جارياً
                        <tr>
                            <td colSpan={ props.header.length + 2 } className="text-center table-status-row">
                                { t( 'table.searching' ) } {/* نص البحث */ }
                            </td>
                        </tr>
                    ) : displayedData.length === 0 ? ( // إذا كانت البيانات فارغة
                        <tr>
                            <td colSpan={ props.header.length + 2 } className="text-center table-status-row">
                                — {/* شرطة للدلالة على عدم وجود بيانات */ }
                            </td>
                        </tr>
                    ) : ( // عرض البيانات
                        displayedData.map( ( item ) => ( // تكرار على كل عنصر في البيانات
                            <tr key={ item.id }> {/* مفتاح فريد لكل صف */ }
                                <td className="cell-muted text-center">{ item.id }</td> {/* عرض المعرف */ }
                                { props.header.map( ( column ) => ( // تكرار على الأعمدة
                                    <td key={ column.key }>
                                        { renderCell( item, column.key ) } {/* عرض محتوى الخلية */ }
                                        {/* عرض شارة "أنت" إذا كان الاسم يطابق المستخدم الحالي */ }
                                        { item[ column.key ] === currentUser.name && (
                                            <span className="you-badge">{ t( 'table.you' ) }</span>
                                        ) }
                                    </td>
                                ) ) }
                                <td> {/* عمود الإجراءات */ }
                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                        {/* زر التعديل - رابط لتعديل العنصر */ }
                                        <Link to={ `${ item.id }` } className="row-action-btn row-action-btn--edit">
                                            <FontAwesomeIcon icon={ faPenToSquare } />
                                        </Link>
                                        {/* زر الحذف - يظهر فقط إذا كان المستخدم ليس هو نفسه */ }
                                        { currentUser.name !== item.name && (
                                            <button
                                                type="button"
                                                className="row-action-btn row-action-btn--delete"
                                                onClick={ () => props.delete( item.id ) } // استدعاء دالة الحذف
                                            >
                                                <FontAwesomeIcon icon={ faTrash } />
                                            </button>
                                        ) }
                                    </div>
                                </td>
                            </tr>
                        ) )
                    ) }
                </tbody>
            </Table>

            {/* تذييل الجدول (اختيار عدد الصفوف والترقيم) */ }
            <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 data-table-footer">
                {/* قائمة منسدلة لاختيار عدد الصفوف في الصفحة */ }
                <Form.Select
                    className="rows-select"
                    onChange={ ( e ) => props.setLimit( e.target.value ) } // تحديث عدد الصفوف
                >
                    <option disabled value="">{ t( 'table.rowsPerPage' ) }</option> {/* الخيار الافتراضي */ }
                    <option value="5">5</option>
                    <option value="8">8</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                </Form.Select>

                {/* مكون الترقيم */ }
                <PaginatedItems
                    itemsPerPage={ props.limit } // عدد العناصر في الصفحة
                    data={ props.data } // البيانات
                    setpage={ props.setpage } // دالة تغيير الصفحة
                    total={ props.total } // العدد الإجمالي
                />
            </div>
        </div>
    );
}